// A valid password must contain at least one uppercase letter, one number, one special character, and be at least 12 characters long.
const PASSWORD_REGEX =
  /^(?=.*\d)(?=.*[`~!@#$%^&*(),.?'";:{}|<>_\-+=/\\[\]])(?!.*\s)(?=.*[A-Z]).{12,}$/;

export function validatePassword(password: string): string | null {
  if (!password || password.trim() === '') {
    return 'This field is required';
  }
  if (password.length > 255) {
    return 'Maximum 255 characters';
  }
  if (!PASSWORD_REGEX.test(password)) {
    return 'Meet all password rules below';
  }

  return null;
}

type ValidatePasswordRequirements = {
  hasMinLength: boolean;
  hasSpecialChar: boolean;
  hasNumber: boolean;
  hasCapitalLetter: boolean;
};

export const validatePasswordRequirements = (
  password: string | undefined
): ValidatePasswordRequirements => ({
  hasMinLength: password?.length >= 12,
  hasSpecialChar: /[`~!@#$%^&*(),.?'";:{}|<>_\-+=/\\[\]]/.test(password || ''),
  hasNumber: /\d/.test(password || ''),
  hasCapitalLetter: /[A-Z]/.test(password || ''),
});
